<template>
    <div class="container-fluid mt-5">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <div class="row">
              <div class="col-6">
                <h2 class="mb-0">Venta</h2>
              </div>
              <div class="col-6 text-right">
              </div>
            </div>
          </template>
            <div class="col-12">
                <el-tabs v-model="activeTab" type="card" @tab-click="handleClick">
                  <!-- IDA -->
                  <el-tab-pane label="Ida" name="Ida">
                    <div v-if="venta.ida.corrida_id">
                    <h3 class="mb-1">Corrida #{{venta.ida.corrida_id+': Subcorrida #'+venta.ida.id}}</h3>
                    <div v-if="venta.ida.tramo" class="row">
                      <div class="col-4">
                        <span>Terminal origen: {{venta.ida.tramo.terminal_origen.nombre}}</span>
                      </div>
                      <div class="col-4">
                        <span>Fecha salida: {{venta.ida.fecha_salida | moment('DD-MM-YYYY')}}</span>
                      </div>
                      <div class="col-2">
                        <base-button class="hover-apolo" type="default" icon size="sm" @click="listaAbordajeModal(venta.ida.corrida_id)">
                          <span class="btn-inner--text">Lista de abordaje</span>
                        </base-button>
                      </div>
                      <div class="col-2">
                        <base-button class="hover-apolo" type="default" icon size="sm" @click="liberarAsientosSubcorridaIda()">
                          <span class="btn-inner--text">Cambiar subcorrida</span>
                        </base-button>
                      </div>
                    </div>
                    <div v-if="venta.ida.tramo" class="row mb-1">
                      <div class="col-4">
                        <span>Terminal destino: {{venta.ida.tramo.terminal_destino.nombre}}</span>
                      </div>
                      <div class="col-4">
                        <span>Hora de salida: {{venta.ida.fecha_salida | moment('HH:mm')}}</span>
                      </div>
                    </div>
                    <div v-if="venta.ida.niveles" class="col-12 mt-3">
                      <label v-if="parseInt(venta.ida.niveles) === 2">&nbsp;&nbsp;&nbsp;Estas en el nivel:&nbsp;{{nivelActual}}</label>
                      <!--INICIA SLIDER DE ASIENTOS-->
                      <div v-show="mostrarNivelUno">
                        <div v-for="(column,indexColumn) in venta.ida.estructura[0]" :key="indexColumn" class="d-flex flex-row align-content-around flex-wrap">
                          <box-item-venta 
                            :token_id="token_id"
                            :venta="venta"
                            :addDetail="addDetail" 
                            :getIdaOVuelta="getIdaOVuelta"
                            :ref="'item'+(indexColumn).toString()+indexFila"
                            :id="'item'+(indexColumn).toString()+indexFila"
                            :permisoAdmin="permisoAdmin"
                            :subcorrida_id="venta.ida.subcorrida_id"
                            :showPayTicketModal="showPayTicketModal"
                            v-model="venta.ida.estructura[0][indexColumn][indexFila]" 
                            v-for="(fila,indexFila) in column" :key="(indexColumn).toString()+indexFila"
                          ></box-item-venta>
                        </div>
                      </div>
                      <div v-show="mostrarNivelDos">
                        <div v-show="parseInt(venta.ida.niveles) === 2" class="col-12">
                          <div v-for="(column,indexColumn) in venta.ida.estructura[1]" :key="indexColumn" class="d-flex flex-row align-content-around flex-wrap">
                            <box-item-venta 
                              :token_id="token_id"
                              :venta="venta"
                              :addDetail="addDetail" 
                              :getIdaOVuelta="getIdaOVuelta"
                              :ref="'item'+(indexColumn).toString()+indexFila"
                              :id="'item'+(indexColumn).toString()+indexFila"
                              :permisoAdmin="permisoAdmin"
                              :subcorrida_id="venta.ida.subcorrida_id"
                              :showPayTicketModal="showPayTicketModal"
                              v-model="venta.ida.estructura[1][indexColumn][indexFila]" 
                              v-for="(fila,indexFila) in column" :key="(indexColumn).toString()+indexFila"
                            ></box-item-venta>
                          </div>
                        </div>
                      </div>
                      <br>
                      <div v-if="parseInt(venta.ida.niveles) === 2" class="App__basic-example-controls text-center">
                        <button class="btn btn-default hover-apolo" @click.prevent="nivelUno()">
                          &laquo; Nivel 1
                        </button>
                        <button class="btn btn-default hover-apolo" @click.prevent="nivelDos()">
                          Nivel 2 &raquo;
                        </button>
                      </div>
                    </div>
                    <div v-if="venta.ida.paraderos_ida && venta.ida.paraderos_vuelta" class="row mt-3" style="z-index: 1001;">
                      <span class="col-1" style="font-size: 13px !important;">Subida:</span>
                      <multiselect class="col-2" v-model="venta.ida.subida" :options="venta.ida.paraderos_ida" :searchable="false" :close-on-select="true" :showLabels="false" placeholder="Seleccione paradero" open-direction="top"></multiselect>
                      <span class="col-1" style="font-size: 13px !important;">Bajada:</span>
                      <multiselect class="col-2" v-model="venta.ida.bajada" :options="venta.ida.paraderos_vuelta" :searchable="false" :close-on-select="true" :showLabels="false" placeholder="Seleccione paradero" open-direction="top"></multiselect>
                      <div v-if="venta.ida.precios.length === 1">
                        <base-button v-if="venta.ida.precios[0].disponible === 1 && venta.ida.precios[0].categoria_asiento_id === 1" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoPrimera()">
                          <span class="btn-inner--text">Blanco Básica</span>
                        </base-button>
                        <base-button v-if="venta.ida.precios[0].disponible === 1 && venta.ida.precios[0].categoria_asiento_id === 2" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoEjecutiva()">
                          <span class="btn-inner--text">Blanco Ejecutiva</span>
                        </base-button>
                        <base-button v-if="venta.ida.precios[0].disponible === 1 && venta.ida.precios[0].categoria_asiento_id === 3" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoConfort()">
                          <span class="btn-inner--text">Blanco Confort</span>
                        </base-button>
                      </div>
                      <div v-if="venta.ida.precios.length === 2">
                        <base-button v-if="venta.ida.precios[0].disponible === 1 && venta.ida.precios[0].categoria_asiento_id === 1" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoPrimera()">
                          <span class="btn-inner--text">Blanco Básica</span>
                        </base-button>
                        <base-button v-if="venta.ida.precios[0].disponible === 1 && venta.ida.precios[0].categoria_asiento_id === 2" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoEjecutiva()">
                          <span class="btn-inner--text">Blanco Ejecutiva</span>
                        </base-button>
                        <base-button v-if="venta.ida.precios[0].disponible === 1 && venta.ida.precios[0].categoria_asiento_id === 3" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoConfort()">
                          <span class="btn-inner--text">Blanco Confort</span>
                        </base-button>
                        <base-button v-if="venta.ida.precios[1].disponible === 1 && venta.ida.precios[1].categoria_asiento_id === 1" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoPrimera()">
                          <span class="btn-inner--text">Blanco Básica</span>
                        </base-button>
                        <base-button v-if="venta.ida.precios[1].disponible === 1 && venta.ida.precios[1].categoria_asiento_id === 2" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoEjecutiva()">
                          <span class="btn-inner--text">Blanco Ejecutiva</span>
                        </base-button>
                        <base-button v-if="venta.ida.precios[1].disponible === 1 && venta.ida.precios[1].categoria_asiento_id === 3" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoConfort()">
                          <span class="btn-inner--text">Blanco Confort</span>
                        </base-button>
                      </div>
                      <div v-if="venta.ida.precios.length === 3">
                        <base-button v-if="venta.ida.precios[0].disponible === 1 && venta.ida.precios[0].categoria_asiento_id === 1" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoPrimera()">
                          <span class="btn-inner--text">Blanco Básica</span>
                        </base-button>
                        <base-button v-if="venta.ida.precios[0].disponible === 1 && venta.ida.precios[0].categoria_asiento_id === 2" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoEjecutiva()">
                          <span class="btn-inner--text">Blanco Ejecutiva</span>
                        </base-button>
                        <base-button v-if="venta.ida.precios[0].disponible === 1 && venta.ida.precios[0].categoria_asiento_id === 3" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoConfort()">
                          <span class="btn-inner--text">Blanco Confort</span>
                        </base-button>
                        <base-button v-if="venta.ida.precios[1].disponible === 1 && venta.ida.precios[1].categoria_asiento_id === 1" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoPrimera()">
                          <span class="btn-inner--text">Blanco Básica</span>
                        </base-button>
                        <base-button v-if="venta.ida.precios[1].disponible === 1 && venta.ida.precios[1].categoria_asiento_id === 2" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoEjecutiva()">
                          <span class="btn-inner--text">Blanco Ejecutiva</span>
                        </base-button>
                        <base-button v-if="venta.ida.precios[1].disponible === 1 && venta.ida.precios[1].categoria_asiento_id === 3" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoConfort()">
                          <span class="btn-inner--text">Blanco Confort</span>
                        </base-button>
                        <base-button v-if="venta.ida.precios[2].disponible === 1 && venta.ida.precios[2].categoria_asiento_id === 1" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoPrimera()">
                          <span class="btn-inner--text">Blanco Básica</span>
                        </base-button>
                        <base-button v-if="venta.ida.precios[2].disponible === 1 && venta.ida.precios[2].categoria_asiento_id === 2" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoEjecutiva()">
                          <span class="btn-inner--text">Blanco Ejecutiva</span>
                        </base-button>
                        <base-button v-if="venta.ida.precios[2].disponible === 1 && venta.ida.precios[2].categoria_asiento_id === 3" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoConfort()">
                          <span class="btn-inner--text">Blanco Confort</span>
                        </base-button>
                      </div>
                    </div>
                    </div>
                  </el-tab-pane>
                  <!-- VUELTA -->
                  <el-tab-pane v-if="payment_details.length > 0" label="Vuelta" name="Vuelta">
                    <div v-if="venta.vuelta.corrida_id">
                    <h3 class="mb-1">Corrida #{{venta.vuelta.corrida_id+': Subcorrida #'+venta.vuelta.id}}</h3>
                    <div v-if="venta.vuelta.tramo" class="row">
                      <div class="col-4">
                        <span>Terminal origen: {{venta.vuelta.tramo.terminal_origen.nombre}}</span>
                      </div>
                      <div class="col-4">
                        <span>Fecha salida: {{venta.vuelta.fecha_salida | moment('DD-MM-YYYY')}}</span>
                      </div>
                      <div class="col-2">
                        <base-button class="hover-apolo" type="default" icon size="sm" @click="listaAbordajeModal(venta.vuelta.corrida_id)">
                          <span class="btn-inner--text">Lista de abordaje</span>
                        </base-button>
                      </div>
                      <div class="col-2">
                        <base-button class="hover-apolo" type="default" icon size="sm" @click="resetVentaVuelta()">
                          <span class="btn-inner--text">Cambiar fecha de salida</span>
                        </base-button>
                      </div>
                    </div>
                    <div v-if="venta.vuelta.tramo" class="row mb-1">
                      <div class="col-4">
                        <span>Terminal destino: {{venta.vuelta.tramo.terminal_destino.nombre}}</span>
                      </div>
                      <div class="col-4">
                        <span>Hora de salida: {{venta.vuelta.fecha_salida | moment('HH:mm')}}</span>
                      </div>
                    </div>
                    <div v-if="venta.vuelta.niveles" class="col-12 mt-3">
                      <label v-if="parseInt(venta.vuelta.niveles) === 2">&nbsp;&nbsp;&nbsp;Estas en el nivel:&nbsp;{{nivelActual}}</label>
                      <!--INICIA SLIDER DE ASIENTOS-->
                      <div v-show="mostrarNivelUno">
                        <div v-for="(column,indexColumn) in venta.vuelta.estructura[0]" :key="indexColumn" class="d-flex flex-row align-content-around flex-wrap">
                          <box-item-venta 
                            :token_id="token_id"
                            :venta="venta"
                            :addDetail="addDetail" 
                            :getIdaOVuelta="getIdaOVuelta"
                            :ref="'item'+(indexColumn).toString()+indexFila"
                            :id="'item'+(indexColumn).toString()+indexFila"
                            :permisoAdmin="permisoAdmin"
                            :subcorrida_id="venta.vuelta.subcorrida_id"
                            :showPayTicketModal="showPayTicketModal"
                            v-model="venta.vuelta.estructura[0][indexColumn][indexFila]" 
                            v-for="(fila,indexFila) in column" :key="venta.vuelta.corrida_id+venta.vuelta.id+(indexColumn).toString()+indexFila"
                          ></box-item-venta>
                        </div>
                      </div>
                      <div v-show="mostrarNivelDos">
                        <div v-if="parseInt(venta.vuelta.niveles) === 2" class="col-12">
                          <div v-for="(column,indexColumn) in venta.vuelta.estructura[1]" :key="indexColumn" class="d-flex flex-row align-content-around flex-wrap">
                            <box-item-venta 
                              :token_id="token_id"
                              :venta="venta"
                              :addDetail="addDetail" 
                              :getIdaOVuelta="getIdaOVuelta"
                              :ref="'item'+(indexColumn).toString()+indexFila"
                              :id="'item'+(indexColumn).toString()+indexFila"
                              :permisoAdmin="permisoAdmin"
                              :subcorrida_id="venta.vuelta.subcorrida_id"
                              :showPayTicketModal="showPayTicketModal"
                              v-model="venta.vuelta.estructura[1][indexColumn][indexFila]" 
                              v-for="(fila,indexFila) in column" :key="venta.vuelta.corrida_id+venta.vuelta.id+(indexColumn).toString()+indexFila"
                            ></box-item-venta>
                          </div>
                        </div>
                      </div>
                      <br>
                      <div v-if="parseInt(venta.vuelta.niveles) === 2" class="App__basic-example-controls text-center">
                        <button class="btn btn-default hover-apolo" @click.prevent="nivelUno()">
                          &laquo; Nivel 1
                        </button>
                        <button class="btn btn-default hover-apolo" @click.prevent="nivelDos()">
                          Nivel 2 &raquo;
                        </button>
                      </div>
                    </div>
                    <div v-if="venta.vuelta.paraderos_ida && venta.vuelta.paraderos_vuelta" class="row mt-3">
                      <span class="col-1" style="font-size: 13px !important;">Subida:</span>
                      <multiselect class="col-2" v-model="venta.vuelta.subida" :options="venta.vuelta.paraderos_ida" :searchable="false" :close-on-select="true" :showLabels="false" placeholder="Seleccione paradero" open-direction="top"></multiselect>
                      <span class="col-1" style="font-size: 13px !important;">Bajada:</span>
                      <multiselect class="col-2" v-model="venta.vuelta.bajada" :options="venta.vuelta.paraderos_vuelta" :searchable="false" :close-on-select="true" :showLabels="false" placeholder="Seleccione paradero" open-direction="top"></multiselect>
                      <div v-if="venta.vuelta.precios.length === 1">
                        <base-button v-if="venta.vuelta.precios[0].disponible === 1 && venta.vuelta.precios[0].categoria_asiento_id === 1" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoPrimera()">
                          <span class="btn-inner--text">Blanco Básica</span>
                        </base-button>
                        <base-button v-if="venta.vuelta.precios[0].disponible === 1 && venta.vuelta.precios[0].categoria_asiento_id === 2" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoEjecutiva()">
                          <span class="btn-inner--text">Blanco Ejecutiva</span>
                        </base-button>
                        <base-button v-if="venta.vuelta.precios[0].disponible === 1 && venta.vuelta.precios[0].categoria_asiento_id === 3" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoConfort()">
                          <span class="btn-inner--text">Blanco Confort</span>
                        </base-button>
                      </div>
                      <div v-if="venta.vuelta.precios.length === 2">
                        <base-button v-if="venta.vuelta.precios[0].disponible === 1 && venta.vuelta.precios[0].categoria_asiento_id === 1" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoPrimera()">
                          <span class="btn-inner--text">Blanco Básica</span>
                        </base-button>
                        <base-button v-if="venta.vuelta.precios[0].disponible === 1 && venta.vuelta.precios[0].categoria_asiento_id === 2" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoEjecutiva()">
                          <span class="btn-inner--text">Blanco Ejecutiva</span>
                        </base-button>
                        <base-button v-if="venta.vuelta.precios[0].disponible === 1 && venta.vuelta.precios[0].categoria_asiento_id === 3" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoConfort()">
                          <span class="btn-inner--text">Blanco Confort</span>
                        </base-button>
                        <base-button v-if="venta.vuelta.precios[1].disponible === 1 && venta.vuelta.precios[1].categoria_asiento_id === 1" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoPrimera()">
                          <span class="btn-inner--text">Blanco Básica</span>
                        </base-button>
                        <base-button v-if="venta.vuelta.precios[1].disponible === 1 && venta.vuelta.precios[1].categoria_asiento_id === 2" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoEjecutiva()">
                          <span class="btn-inner--text">Blanco Ejecutiva</span>
                        </base-button>
                        <base-button v-if="venta.vuelta.precios[1].disponible === 1 && venta.vuelta.precios[1].categoria_asiento_id === 3" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoConfort()">
                          <span class="btn-inner--text">Blanco Confort</span>
                        </base-button>
                      </div>
                      <div v-if="(venta.vuelta.precios.length === 3)">
                        <base-button v-if="venta.vuelta.precios[0].disponible === 1 && venta.vuelta.precios[0].categoria_asiento_id === 1" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoPrimera()">
                          <span class="btn-inner--text">Blanco Básica</span>
                        </base-button>
                        <base-button v-if="venta.vuelta.precios[0].disponible === 1 && venta.vuelta.precios[0].categoria_asiento_id === 2" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoEjecutiva()">
                          <span class="btn-inner--text">Blanco Ejecutiva</span>
                        </base-button>
                        <base-button v-if="venta.vuelta.precios[0].disponible === 1 && venta.vuelta.precios[0].categoria_asiento_id === 3" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoConfort()">
                          <span class="btn-inner--text">Blanco Confort</span>
                        </base-button>
                        <base-button v-if="venta.vuelta.precios[1].disponible === 1 && venta.vuelta.precios[1].categoria_asiento_id === 1" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoPrimera()">
                          <span class="btn-inner--text">Blanco Básica</span>
                        </base-button>
                        <base-button v-if="venta.vuelta.precios[1].disponible === 1 && venta.vuelta.precios[1].categoria_asiento_id === 2" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoEjecutiva()">
                          <span class="btn-inner--text">Blanco Ejecutiva</span>
                        </base-button>
                        <base-button v-if="venta.vuelta.precios[1].disponible === 1 && venta.vuelta.precios[1].categoria_asiento_id === 3" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoConfort()">
                          <span class="btn-inner--text">Blanco Confort</span>
                        </base-button>
                        <base-button v-if="venta.vuelta.precios[2].disponible === 1 && venta.vuelta.precios[2].categoria_asiento_id === 1" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoPrimera()">
                          <span class="btn-inner--text">Blanco Básica</span>
                        </base-button>
                        <base-button v-if="venta.vuelta.precios[2].disponible === 1 && venta.vuelta.precios[2].categoria_asiento_id === 2" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoEjecutiva()">
                          <span class="btn-inner--text">Blanco Ejecutiva</span>
                        </base-button>
                        <base-button v-if="venta.vuelta.precios[2].disponible === 1 && venta.vuelta.precios[2].categoria_asiento_id === 3" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoConfort()">
                          <span class="btn-inner--text">Blanco Confort</span>
                        </base-button>
                      </div>
                    </div>
                  </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            <!--ARRAY LISTA DE BOLETOS-->
            <div v-if="venta.ida" class="row mt-3 ml-1">
              <span>Boletos en venta:</span>
              <div style="overflow-x: scroll; width: auto;">
                <table class="table table-responsive table-flush">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Asiento</th>
                      <th style="min-width: 250px; padding:auto;">Nombre</th>
                      <th style="min-width: 110px; padding:auto;">Edad</th>
                      <th style="min-width: 200px; padding:auto;">Descuento</th>
                      <th>Precio Lista</th>
                      <th>Descuento</th>
                      <th>Precio final</th>
                    </tr>
                  </thead>
                  <tbody v-if="payment_details.length">
                    <tr v-for="(detail,index) in payment_details" :key="detail.id">
                      <td>
                        <span>{{detail.tipo_viaje}}</span>
                        <button @click="deleteDetail(index)" type="button" class="btn btn-danger btn-sm">
                          Borrar
                        </button>
                      </td>
                      <td>
                        <button @click="changeDetail(index)" :disabled="isDisabledButtonAsiento(index)" :class="detail.classActive ? 'btn-success' : 'btn-default'" type="button" class="btn btn-sm">
                          {{detail.asiento}}
                        </button>
                      </td>
                      <td>
                        <base-input
                          placeholder="Nombre completo"
                          v-model="detail.nombre_pasajero">
                        </base-input>
                      </td>
                      <td>
                        <ValidationProvider name="edad" rules="integer|between:1,120" v-slot="{ errors }">
                          <base-input
                            placeholder="Edad"
                            v-model="detail.edad">
                          </base-input>
                          <validation-error :errors="errors" />
                        </ValidationProvider>
                      </td>
                      <td>
                        <multiselect v-if="activeTab === 'Ida'" @select="checkDescuento($event, index)" v-model="detail.descuento" :options="descuentos" open-direction="bottom" :searchable="false" :close-on-select="true" :clear-on-select="false" placeholder="Selecione descuento" label="nombre" track-by="id" :showLabels="false"></multiselect>
                        <multiselect v-if="activeTab === 'Vuelta'" @select="checkDescuento($event, index)" v-model="detail.descuento" :options="descuentosVuelta" open-direction="bottom" :searchable="false" :close-on-select="true" :clear-on-select="false" placeholder="Seleccione descuento" label="nombre" track-by="id" :showLabels="false"></multiselect>
                      </td>
                      <td>
                        <span v-if="detail.precio_taquilla">${{detail.precio_taquilla}}</span>
                      </td>
                      <td v-if="detail.descuento">
                        <span v-if="detail.descuento.valor === 0"></span>
                        <span v-else>{{Math.trunc(detail.descuento.valor)+' '+detail.descuento.tipo_valor}}</span>
                      </td>
                      <td>
                        <span v-if="detail.precio_taquilla">${{detail.monto_total_pagar = calculateFinal(index).toFixed(2)}}</span>
                      </td>
                    </tr>
                    <tr style="background-color: #CEECF5;">
                      <td colspan="7" align="right"><strong>Total:</strong></td>
                      <td>${{venta.pago_total = calculateTotal}}</td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="6">
                        No hay boletos agregados
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-if="validacionEdad" class="mt-3 text-left">
              <span style="color: red">No hay un solo adulto en los boletos en venta. Es necesario informar que se necesita una carta responsiva para cada menor durante el abordaje.</span><a href="/documents/CARTARESPONSIVAMENOR2023.pdf" target="_blank" style="color:#0068a0 !important"> Abrir carta</a>
            </div>
            <div v-if="payment_details.length" class="mt-3 text-right">
              <base-button class="hover-apolo" type="default" size="lg" @click="validateTickets()">
                <span class="btn-inner--text">Pagar todos los boletos</span>
              </base-button>
            </div>
          
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center flex-wrap"
          >
          </div>
        </card>
      </div>
      <!-- MODAL Componente Selección de Subcorrida -->
      <modal :show.sync="showSeleccionSubcorridaModal" modal-classes="modal-primary" size="xl">
        <form class="new-event--form" @submit.prevent="selectSubcorrida">
          <div class="row">
            <div class="col-4">
              <base-input label="Fecha">
              <date-picker
                v-model="subcorrida.fecha_salida"
                :format="'DD-MM-YYYY'"
                :lang="'es'"
              ></date-picker>
              </base-input>
              <validation-error :errors="apiValidationErrors.fecha_salida" />
              <span v-if="validacion_fecha_salida != null">
                <small class="argon-error" v-text="validacion_fecha_salida"/>
              </span>
            </div>
            <div class="col-5">
              <base-input label="Terminal Origen">
                <multiselect :disabled="isDisabledOrigen" v-model="subcorrida.terminal_origen" :options="terminales" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Seleccione origen" :custom-label="nombreAbreviatura" track-by="id" :showLabels="false"></multiselect>
              </base-input>
              <validation-error :errors="apiValidationErrors.terminal_origen_id" />
            </div>
            <div class="col-2 mt-6">
              <button v-if="activeTab === 'Ida'" :disabled="isDisabledIntercambiar" type="button" v-bind:class="{ hoverApolo: isActiveHover }" class="btn btn-default ml-auto" @click="Intercambiar()">Intercambiar</button>
            </div>
          </div>
          <div class="row">
            <div class="col-4"></div>
            <base-input class="col-5" label="Terminal Destino">
              <multiselect :disabled="isDisabledDestino" v-model="subcorrida.terminal_destino" :options="terminales" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecione destino" :custom-label="nombreAbreviatura" track-by="id" :showLabels="false"></multiselect>
            </base-input>
            <validation-error :errors="apiValidationErrors.terminal_destino_id" />
            <div class="col-3"></div>
          </div>
          <br>
          <span>Subcorridas:</span>
          <br>
          <el-table
              class="table-responsive align-items-center table-flush"
              header-row-class-name="thead-light"
              :data="subcorridas"
              @sort-change="sortChange"
              highlight-current-row
              @current-change="handleCurrentChange"
            >
              <div slot="empty" v-if="loading">
                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
              </div>

              <div slot="empty" v-if="subcorridas">
                Sin datos disponibles
              </div>
  
              <el-table-column label="# Corrida">
                <div style="cursor: pointer;" slot-scope="{ row }" class="table-actions">
                  <span>{{row.attributes.corrida_id}}</span>
                </div>
              </el-table-column>
              <el-table-column label="Fecha">
                <div style="cursor: pointer;" slot-scope="{ row }">
                  <span>{{row.attributes.fecha_salida | moment('DD-MM-YYYY')}}</span>
                </div>
              </el-table-column>
              <el-table-column label="Hora">
                <div style="cursor: pointer;" slot-scope="{ row }">
                  <span>{{row.attributes.fecha_salida | moment('HH:mm')}}</span>
                </div>
              </el-table-column>
              <el-table-column label="Día">
                <div style="cursor: pointer;" slot-scope="{ row }">
                  <span>{{row.attributes.dia}}</span>
                </div>
              </el-table-column>
              <el-table-column label="Origen">
                <div style="cursor: pointer;" slot-scope="{ row }">
                  <span>{{row.attributes.tramo.terminal_origen.nombre +'('+ row.attributes.tramo.terminal_origen.abreviatura+')'}}</span>
                </div>
              </el-table-column>
              <el-table-column label="Destino">
                <div style="cursor: pointer;" slot-scope="{ row }">
                  <span>{{row.attributes.tramo.terminal_destino.nombre +'('+ row.attributes.tramo.terminal_destino.abreviatura+')'}}</span>
                </div>
              </el-table-column>
              <el-table-column label="Disponibilidad">
                <div style="cursor: pointer;" slot-scope="{ row }">
                  <span v-if="row.attributes.disponibilidad.B > 0">{{row.attributes.disponibilidad.B+'B'}}<span v-if="row.attributes.disponibilidad.E > 0">, </span></span>
                  <span v-if="row.attributes.disponibilidad.E > 0">{{row.attributes.disponibilidad.E+'E'}}<span v-if="row.attributes.disponibilidad.C > 0">, </span></span>
                  <span v-if="row.attributes.disponibilidad.C > 0">{{row.attributes.disponibilidad.C+'C'}}</span>
                </div>
              </el-table-column>
            </el-table>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center flex-wrap"
          >
          <br>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            />
          </div>
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>

        <template slot="footer">
          <button v-if="activeTab === 'Vuelta'" type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cancelar</button>
          <button v-if="activeTab === 'Ida'" type="button" class="btn btn-primary hover-apolo ml-auto" @click="salir">Salir</button>
        </template>
      </modal>
      <!-- MODAL VER LISTA DE ABORDAJE -->
      <modal :show.sync="showListaAbordajeModal" :close-on-backdrop="true" modal-classes="modal-primary" size="lg">
        <div class="row">
          <h6 slot="header" class="mb-0 modal-title col-6">Lista de abordaje de corrida</h6>
          <button class="btn btn-default hover-apolo new-event--add ml-2 col-4" align="right" @click="imprimirLista()">Imprimir</button>
        </div>
        <form class="new-event--form"> 
          <span v-if="TotalVentaCorrida != null">Total de venta corrida: ${{ TotalVentaCorrida }}</span>
          <br>
          <el-table
              class="table-responsive align-items-center table-flush"
              header-row-class-name="thead-light"
              :data="listaAbordaje"
              @sort-change="sortChange"
            >
              <div slot="empty" v-if="loading">
                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
              </div>
  
              <div slot="empty" v-if="listaAbordaje">
                Sin datos disponibles
              </div>
  
              <el-table-column label="Asiento" prop="attributes.numero" width="100px"/>
              <el-table-column label="Categoría" prop="attributes.categoria.nombre" width="150px"/>
              <el-table-column label="Pasajero">
                <div slot-scope="{ row }" class="table-actions">
                  <div v-if="row.attributes.pasajeros">
                    <div v-for="(pasajero, index) in row.attributes.pasajeros" :key="pasajero.id">
                      <span>{{pasajero}}</span> 
                    </div>
                  </div>
                  <div v-else>
                    <span>Sin Boletos</span>
                  </div>
                </div> 
              </el-table-column>
              <el-table-column label="Sube">
                <div slot-scope="{ row }" class="table-actions">
                  <div v-if="row.attributes.pasajeros">
                    <div v-for="(pasajero, index) in row.attributes.pasajeros" :key="pasajero.id">
                      <span>{{ row.attributes.sube[index] }}</span> 
                    </div>
                  </div>
                  <div v-else>
                    <span>-</span>
                  </div>
                </div> 
              </el-table-column>
              <el-table-column label="Baja">
                <div slot-scope="{ row }" class="table-actions">
                  <div v-if="row.attributes.pasajeros">
                    <div v-for="(pasajero, index) in row.attributes.pasajeros" :key="pasajero.id">
                      <span>{{ row.attributes.baja[index] }}</span> 
                    </div>
                  </div>
                  <div v-else>
                    <span>-</span>
                  </div>
                </div> 
              </el-table-column>
              <el-table-column label="Valor Boleto">
                <div slot-scope="{ row }" class="table-actions">
                  <div v-if="row.attributes.valor_venta_boleto">
                    <div v-for="(valor, index) in row.attributes.valor_venta_boleto" :key="valor.id">
                      <span>{{valor}}</span> 
                    </div>
                  </div>
                  <div v-else>
                    <span>-</span>
                  </div>
                </div> 
              </el-table-column>
              <el-table-column label="Descuento">
                <div slot-scope="{ row }" class="table-actions">
                  <div v-if="row.attributes.detalles_descuento">
                    <div v-for="(valor, index) in row.attributes.detalles_descuento" :key="valor.id">
                      <span>{{valor}}</span> 
                    </div>
                  </div>
                  <div v-else>
                    <span>-</span>
                  </div>
                </div> 
              </el-table-column>
          </el-table>
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>
  
        <template slot="footer">
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showListaAbordajeModal = false">Cerrar</button>
        </template>
      </modal>
      <!-- MODAL VER IMPRIMIR LISTA DE ABORDAJE -->
      <modal :show.sync="showPrintListaAbordajeModal" :hasParent="true" modal-classes="modal-primary" size="sm">
        <h6 slot="header" class="mb-0 modal-title">Lista de abordaje</h6>
        <form class="new-event--form">
          <span>Se ha impreso la lista de abordaje</span>
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>
  
        <template slot="footer">
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showPrintListaAbordajeModal = false">Cerrar</button>
        </template>
      </modal>
      <!-- MODAL VER MENSAJE DESCUENTO -->
      <modal :show.sync="showDescuentoMensajeTaquilla" modal-classes="modal-primary" size="sm">
        <h6 slot="header" class="mb-0 modal-title">Información</h6>
        <form class="new-event--form">
          <span v-if="mensaje_taquilla">{{mensaje_taquilla}}</span>
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>
  
        <template slot="footer">
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showDescuentoMensajeTaquilla = false, mensaje_taquilla = null">Aceptar</button>
        </template>
      </modal>
      <!-- MODAL VER INPUT DESCUENTO CORTESIA -->
      <modal :show.sync="showDescuentoCortesia" modal-classes="modal-primary" size="sm">
        <h6 slot="header" class="mb-0 modal-title">Cortesía SIVO</h6>
        <form class="new-event--form">
          <base-input label="Describe la razón para aplicar cortesía:">
            <textarea class="form-control" v-model="cortesia.razon" rows="3"></textarea>
          </base-input>
          
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>
  
        <template slot="footer">
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="aceptarCortesia()">Aceptar</button>
        </template>
      </modal>
      <!-- MODAL PAGAR -->
      <modal :show.sync="showPayTicketModal" modal-classes="modal-primary" size="sm">
        <h6 slot="header" class="mb-0 modal-title">Total a pagar: ${{venta.pago_total}}</h6>
        <form v-if="showPayTicketModal" class="new-event--form">
          <div class="row mt-2">
            <base-checkbox v-if="reserva" class="col-5 ml-3" v-model="venta.es_pago_contado">
              Contado
            </base-checkbox>
            <base-checkbox v-else disabled class="col-5 ml-3" v-model="venta.es_pago_contado">
              Contado
            </base-checkbox>
            <base-checkbox v-if="reserva" class="col-4" v-model="venta.fue_reserva">
              Reserva
            </base-checkbox>
            <div v-else class="col-6 mb-2" style="color:red; font-size: 12px;">
              No se cumplen los criterios para reservar
            </div>
            <br>
            <base-input
              class="col-12"
              placeholder="Correo electrónico"
              v-model="venta.email"
              @input="venta.email = venta.email.trim().toLowerCase()"
            />
            <div class="col-12"  style="color:red; font-size: 12px; bottom: 25px;">
              Indicar al usuario revisar su bandeja de spam
            </div>
            <validation-error class="col-12" :errors="apiValidationErrors.email" />
            <base-input
              class="col-12"
              placeholder="Telefono"
              v-model="venta.telefono"
              @input="venta.telefono = venta.telefono.replace(/\D/g, '')"
            />
            <validation-error class="col-12" :errors="apiValidationErrors.telefono" />
            <span class="col-12">Métodos de pago</span>
            <base-checkbox class="col-9 ml-3" v-model="venta.efectivo" :disabled="venta.pago_tarjeta">
              Efectivo
            </base-checkbox>
            <span v-if="reserva && venta.fue_reserva" class="col-12 text-right">Cantidad de abono minimo: <strong>${{(porcentaje_minimo_abono * .01) * this.calculateTotal}}</strong></span>
            <span class="col-12 text-right">Cantidad restante a pagar MXN <strong>${{calculateRestante}}</strong></span>
            <span class="col-8 text-right">Se paga con MXN</span>
            <ValidationProvider class="col-4 text-right" name="Cantidad MXN" rules="integer:0,100000" v-slot="{ errors }">
              <base-input
                :disabled="venta.pago_tarjeta"
                placeholder="Cantidad"
                v-model="venta.efectivo_mxn"
              />
              <validation-error class="col-12"  :errors="errors" />
            </ValidationProvider>
            <!--
            <span class="col-8 text-right">Se paga con USD</span>
            <ValidationProvider class="col-4 text-right" name="cantidad USD" rules="integer:0,100000" v-slot="{ errors }">
              <base-input
                placeholder="Cantidad"
                v-model="venta.efectivo_usd"
              />
              <validation-error class="col-12" :errors="errors" />
            </ValidationProvider>
            
            <span class="col-12 text-right">Tipo de cambio: ${{venta.tasa_usd_mxn}} En pesos: ${{venta.tasa_usd_mxn * venta.efectivo_usd}}</span>
            -->
            <span class="col-12 text-right">Cambio: ${{calculateCambio}}</span>

            <base-checkbox class="col-9 ml-3" v-model="venta.pago_tarjeta" :disabled="venta.efectivo">
              Tarjeta
            </base-checkbox>
            <pulse-loader class="text-center col-12" v-if="loadingSpinner" :loading="loadingSpinner" :color="color" :size="size"></pulse-loader>
            <div v-else class="col-12">
              <p v-if="mensaje_pago_tarjeta != null" class="col-12" style="color: green !important; margin-left: -15px !important;">{{ mensaje_pago_tarjeta }}</p>
              <p v-if="mensaje_error_pago_tarjeta != null" class="col-12" style="color: red !important; margin-left: -15px !important;">{{ mensaje_error_pago_tarjeta }}</p>
              <div style="margin-top: -20px !important;">
                <ValidationProvider class="col-12" name="cantidad a pagar con tarjeta" rules="integer:1,100000" v-slot="{ errors }">
                  <base-input v-if="venta.pago_tarjeta"
                    disabled
                    placeholder="Cantidad a pagar"
                    v-model="venta.tarjeta"
                  />
                  <validation-error :errors="errors" />
                </ValidationProvider>
              </div>
              <div style="margin-top: -20px !important;">
                <base-input v-if="venta.pago_tarjeta"
                  disabled
                  placeholder="Folio tarjeta"
                  v-model="venta.folio_tarjeta"
                />
                <validation-error :errors="apiValidationErrors.folio_tarjeta" />
              </div>
            </div> 
            <!--
            <base-checkbox class="col-9 ml-3" v-model="venta.pago_deposito">
              Depósito a cuenta
            </base-checkbox>
            <ValidationProvider class="col-12" name="cantidad a pagar con deposito" rules="integer:1,100000" v-slot="{ errors }">
              <base-input v-if="venta.pago_deposito"
                placeholder="Cantidad a pagar"
                v-model="venta.deposito"
              />
              <validation-error class="col-12" :errors="errors" />
            </ValidationProvider>
            <ValidationProvider class="col-12" name="folio de pago con deposito" rules="numeric" v-slot="{ errors }">
              <base-input v-if="venta.pago_deposito"
                placeholder="Folio deposito"
                v-model="venta.folio_deposito"
              />
              <validation-error class="col-12" :errors="errors" />
            </ValidationProvider>
            <validation-error class="col-12" :errors="apiValidationErrors.folio_deposito" />
            -->
            <validation-error class="col-12" :errors="apiValidationErrors.monto" />
            <validation-error class="col-12" :errors="apiValidationErrors.efectivo_mxn" />
            <span class="col-12 text-right"><strong>Acumulado de pagos: ${{calculateAcumulado}}</strong></span>
          </div>
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>
  
        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="payBefore()">Pagar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" :disabled="disabledCancelPay" @click="showPayTicketModal = false">Cancelar</button>
        </template>
        <!-- MODAL AUTORIZA PAGO CON DESCUENTO -->
        <modal :show.sync="showAutorizaPagoDescuentoModal" :hasParent="true" modal-classes="modal-primary" size="sm">
          <h6 slot="header" class="mb-0 modal-title">Autorizar pago con descuento</h6>
          <form class="new-event--form" @submit.prevent="authPagoDescuento">
            <base-input label="Token"
                        placeholder="Ingrese token"
                        v-model="auth.token"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.token"/>
            <!--
            <base-input label="Usuario"
                        placeholder="Ingrese usuario"
                        v-model="auth.usuario"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.usuario" />
            <base-input label="Contraseña"
                        placeholder="Ingrese contraseña"
                        v-model="auth.password"
                        type="password"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.password"/>
            <validation-error :errors="apiValidationErrors.permiso"/>
            -->
            <input type="hidden" class="new-event--start"/>
            <input type="hidden" class="new-event--end"/>
          </form>
    
          <template slot="footer">
            <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="authPagoDescuento">Autorizar</button>
            <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showAutorizaPagoDescuentoModal = false, showPayTicketModal = false">Cancelar</button>
          </template>
        </modal>
        <!-- MODAL BOLETOS PAGO -->
        <modal  :show.sync="showBoletosPagoModal" :hasParent="true" modal-classes="modal-primary" size="sm">
          <h6 slot="header" class="mb-0 modal-title">Boletos</h6>
          <form class="new-event--form" v-if="(boletos.length > 0)">
            <div v-for="boleto in boletos" :key="boleto.id">
              <li>Boleto: {{boleto.id}}</li>
              <li>PASAJERO: {{boleto.nombre_pasajero}}</li>
              <li v-if="boleto.paradero_origen">Origen: {{boleto.paradero_origen}}</li>
              <li v-if="boleto.paradero_destino">Destino: {{boleto.paradero_destino}}</li>
              <li>Fecha viaje: {{boleto.fecha_salida | moment('DD-MM-YYYY')}}</li>
              <li>Hora viaje: {{boleto.fecha_salida | moment('HH:mm')}}</li>
              <li>Asiento:
                <span v-if="(boleto.asiento === null)">Blanco / </span>
                <span v-else>{{boleto.asiento+' / '}} </span>
                <span v-if="(boleto.categoria_asiento_id === 1)">Básica</span>
                <span v-if="(boleto.categoria_asiento_id === 2)">Ejecutiva</span>
                <span v-if="(boleto.categoria_asiento_id === 3)">Confort</span>
              </li>
              <li>Subida: {{boleto.paradero_origen}}</li>
              <li>Bajada: {{boleto.paradero_destino}}</li>
              <li v-if="boleto.descuento">Descuento: {{boleto.descuento.nombre}}</li>
              <li v-if="boleto.cortesia_razon">Razón cortesía: {{boleto.cortesia_razon}}</li>
              <li>Valor pasaje: {{boleto.monto_total_pagar}}</li>
              <li>{{boleto.resumen_pago}}</li>
              <li>Clave facturación: {{boleto.clave_facturacion}}</li>
              <hr>
              <li>www.apoloplatinum.mx</li>
              <hr>
            </div>
            
            <input type="hidden" class="new-event--start"/>
            <input type="hidden" class="new-event--end"/>
          </form>
    
          <template slot="footer">
            <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="reload()">Cerrar</button>
          </template>
        </modal>
        <!-- MODAL BOLETOS PAGO RESERVA -->
        <modal  :show.sync="showBoletosPagoReservaModal" :hasParent="true" modal-classes="modal-primary" size="sm">
          <h6 slot="header" class="mb-0 modal-title">Boletos</h6>
          <form class="new-event--form" v-if="(boletos.length > 0)">
            <div v-for="boleto in boletos" :key="boleto.id">
              <span>Comprobante: Reserva de pasaje</span>
              <li>Boleto: {{boleto.id}}</li>
              <li>PASAJERO: {{boleto.nombre_pasajero}}</li>
              <li v-if="boleto.paradero_origen">Origen: {{boleto.paradero_origen}}</li>
              <li v-if="boleto.paradero_destino">Destino: {{boleto.paradero_destino}}</li>
              <li>Fecha viaje: {{boleto.fecha_salida | moment('DD-MM-YYYY')}}</li>
              <li>Hora viaje: {{boleto.fecha_salida | moment('HH:mm')}}</li>
              <li>Asiento: {{boleto.asiento+' / '}} 
                <span v-if="(boleto.categoria_asiento_id === 1)">Básica</span>
                <span v-if="(boleto.categoria_asiento_id === 2)">Ejecutiva</span>
                <span v-if="(boleto.categoria_asiento_id === 3)">Confort</span>
              </li>
              <li>Subida: {{boleto.paradero_origen}}</li>
              <li>Bajada: {{boleto.paradero_destino}}</li>
              <li v-if="boleto.descuento_id">Descuento: {{boleto.descuento_id}}</li>
              <li>Valor pasaje: {{boleto.monto_total_pagar}}</li>
              <li>Monto abonado: {{calculateAcumulado}}</li>
              <li>{{boleto.resumen_pago}}</li>
              <br>
              <span>Saldo a pagar: {{boleto.monto_total_pagar - calculateAcumulado}}</span>
              <hr>
              <span class="text-center">Reserva puede ser confirmada en cualquiera de nuestras agencias a lo largo del pais</span>
              <hr>
              <span class="text-center">Reserva valida hasta: 2 horas antes de salida</span>
              <li>www.apoloplatinum.mx</li>
              <hr>
            </div>
            
            <input type="hidden" class="new-event--start"/>
            <input type="hidden" class="new-event--end"/>
          </form>
    
          <template slot="footer">
            <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="reload()">Cerrar</button>
          </template>
        </modal>
      </modal>
    </div>
  </template>
  <script>
  import Vue from 'vue';
  import {Impresora} from "@/printer/Impresora.js";
  import ImpresionBoletos from "./ImpresionBoletos.vue";
  import ImpresionBoletos2 from "./ImpresionBoletos2.vue";
  import ImpresionBoletosBlanco from "./ImpresionBoletosBlanco.vue";
  import ImpresionBoletosReserva from "./ImpresionBoletosReserva.vue";
  import ImpresionListaAbordaje from "./ImpresionListaAbordaje.vue";
  import formMixin from "@/mixins/form-mixin";
  import ValidationError from "@/components/ValidationError.vue";
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import { BasePagination, Modal } from "@/components/";
  import {
    Tabs,
    TabPane,
    Table,
    TableColumn,
    DropdownMenu,
    DropdownItem,
    Dropdown,
    Tooltip,
    Select,
    Option,
    RadioButton,
    Button,
  } from "element-ui";
  import swal from "sweetalert2";
  import "sweetalert2/dist/sweetalert2.css";
  import Multiselect from 'vue-multiselect';
  import BoxItemVenta from "./BoxItemVenta.vue";
  import { ValidationProvider, extend } from 'vee-validate';
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
  import { integer, numeric } from 'vee-validate/dist/rules';
  extend('integer:0,100000', { 
    ...integer 
  });
  extend('integer:1,100000', { 
    ...integer 
  });

  extend('numeric', { 
    ...numeric 
  });
  
  export default {
    layout: "DashboardLayout",
  
    components: {
      ValidationProvider,
      BoxItemVenta,
      Modal,
      DatePicker,
      Multiselect,
      ValidationError,
      BasePagination,
      [Tooltip.name]: Tooltip,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Tabs.name]: Tabs,
      [TabPane.name]: TabPane,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Select.name]: Select,
      [Option.name]: Option,
      [Button.name]: Button,
      PulseLoader
    },

    mixins: [formMixin],
  
    data() {
      return {
        corrida_impresion: [],
        validacionEdad: false,
        boletos: {},
        cambiando_asiento: false,
        asiento_index: null,
        token_id: null,
        reservar_activado: 0,
        horas_eliminar_reserva_antes_salida: null,
        porcentaje_minimo_abono: null,
        permiso_reserva: null,
        reserva: false,
        descuentos: [],
        descuentosVuelta: [],
        terminales: [],
        subcorridas: [],
        listaAbordaje: [],
        mostrarNivelUno: true,
        mostrarNivelDos: false,
        nivelActual: '1',
  
        sort: "created_at",
  
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [{value:'5', descripcion: '5 subcorridas por página'},
          {value:'10', descripcion: '10 subcorridas por página'},
          {value:'25', descripcion: '25 subcorridas por página'},
          {value:'50', descripcion: '50 subcorridas por página'}],
        },
        total: 0,
        loading: true,
        showSeleccionSubcorridaModal: false,
        showListaAbordajeModal: false,
        showPrintListaAbordajeModal: false,
        showDescuentoMensajeTaquilla: false,
        showDescuentoCortesia: false,
        cortesia: {
          type: "descuento",
          id: null,
          razon: null,
        },
        cortesia_index: null,
        cortesia_razon_global: null,
        showPayTicketModal: false,
        showAutorizaPagoDescuentoModal: false,
        showBoletosPagoModal: false,
        showBoletosPagoReservaModal: false,

        isActiveHover: false,
        activeTab: 'Ida',
        vuelta: false,
        validacion_fecha_salida: null,
        subcorrida: {
          type: "subcorrida",
          fecha_salida: new Date(),
          hoy: new Date(),
          terminal_origen: null,
          terminal_destino: null,
          agencia: null,
        },
        payment_details: [],
        mensaje_taquilla: null,
        permiso: {},
        auth: {
          type: "autorizar",
          usuario: null,
          password: null,
          permiso: null,
          token: null
        },
        venta_pago: {
          type: 'venta_boleto'
        },
        venta: {
          ida:{
            subcorrida_id: null,
            tramo: null,
            paradero_origen: null,
            paradero_destino: null,
            agencia_id: null,
            monto: null,
            asientos: [],
            tramos: {},
            bajada: null,
            subida: null,
            precios: null,
          },
          vuelta:{
            subcorrida_id: null,
            paradero_origen: null,
            paradero_destino: null,
            agencia_id: null,
            monto: null,
            email: null,
            telefono: null,
            asientos: [],
            tramos: {},
            bajada: null,
            subida: null,
          },
          es_pago_contado: true,
          fue_reserva: false,
          efectivo: true,
          efectivo_mxn: null,
          efectivo_usd: null,
          tarjeta: null,
          folio_tarjeta: null,
          deposito: null,
          folio_deposito: null,
          total_metodos: null,
          cambio: null,
          saldo_efectivo_mxn: null,
          token: null,
          email: null,
          telefono: null,
          pago_tarjeta: false,
          pago_deposito: false,
          descuento_validacion: null,
        },
        loadingSpinner: false,
        color: '#0068a0',
        size: '30px',
        mensaje_pago_tarjeta: null,
        mensaje_error_pago_tarjeta: null,
        disabledCancelPay: false,
        permisoAdmin: false,
        TotalVentaCorrida: null,
        subcorridaRequestId: 0
      };
    },
    //funciones para calculos automaticos
    computed: {
      calculateTotal: function(){
        var result=0.0;
        for(var i=0;i<this.payment_details.length;i++){
          if(this.payment_details[i] !== undefined){
            if(this.payment_details[i].descuento === undefined || this.payment_details[i].descuento === null){
              result = result + parseInt(this.payment_details[i].precio_taquilla);
            }else{
              if(this.payment_details[i].descuento.tipo_valor === '%'){
                result = result + (parseInt(this.payment_details[i].precio_taquilla) - ((this.payment_details[i].precio_taquilla) * (parseInt(this.payment_details[i].descuento.valor)/100)));
              }else{
                result = result + (parseInt(this.payment_details[i].precio_taquilla) - parseInt(this.payment_details[i].descuento.valor));
              }
            }
          }
        }
        if(result < 0){
          result = 0.0;
        }
        return result.toFixed(2);
      },

      calculateRestante: function(){
        var result = this.calculateTotal;
        if(this.venta.efectivo_mxn){
          result = (result - Number(this.venta.efectivo_mxn));
        }
        if(this.venta.efectivo_usd){
          result = result - Number((this.venta.tasa_usd_mxn * this.venta.efectivo_usd));
        }
        if(this.venta.tarjeta){
          result = result - Number(this.venta.tarjeta);
        }
        if(this.venta.deposito){
          result = result - Number(this.venta.deposito);
        }
        if(result < 0){
          result = 0;
        }
        return result;
      },

      calculateCambio: function(){
        var result = 0.0;
        if(this.calculateRestante === 0){
          var result = this.calculateTotal;
          if(this.venta.efectivo_mxn){
            result = result - Number(this.venta.efectivo_mxn);
          }
          if(this.venta.efectivo_usd){
            result = result - Number(this.venta.tasa_usd_mxn * this.venta.efectivo_usd);
          }
          if(this.venta.pago_tarjeta){
            result = result - Number(this.venta.tarjeta);
          }
          if(this.venta.pago_deposito){
            result = result - Number(this.venta.deposito);
          }
          if(result < 0){
            result = Math.abs(result);
          }
          return result.toFixed(2);
        }
        return result.toFixed(2);
      },

      calculateAcumulado: function(){
        var result = 0.0;
        if(this.venta.efectivo_mxn){
          result = result + Number(this.venta.efectivo_mxn);
        }
        if(this.venta.efectivo_usd){
          var usd = this.venta.tasa_usd_mxn * this.venta.efectivo_usd;
          result = result + Number(usd);
        }
        if(this.venta.tarjeta){
          result = result + Number(this.venta.tarjeta);
        }
        if(this.venta.deposito){
          result = result + Number(this.venta.deposito);
        }
        return Number(result).toFixed(2);
      },
      
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
  
      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      isDisabledOrigen(){
        if(this.activeTab === 'Ida'){
          return false;
        }else{
          return true;
        }
      },
      isDisabledDestino(){
        if(!this.subcorrida.terminal_origen || this.activeTab === 'Vuelta'){
          return true;
        }else{
          return false;
        }
      },
      isDisabledIntercambiar(){
        if(this.subcorrida.terminal_origen && this.subcorrida.terminal_destino){
          this.isActiveHover = true;
          return false;
        }else{
          this.isActiveHover = false;
          return true;
        }
      },
    },

    mounted(){
      //const date = new Date();
      //this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    },

    created() {
      this.getRol();
      //this.createToken();
      this.getTerminales();
      //this.getDescuentos();
      this.getOpciones();
      this.validatePermisoReserva();
    },
  
    watch: {
      'subcorrida.fecha_salida': {
        handler: "getListDebounced",
        immediate: false,
      },
      'subcorrida.terminal_origen': {
        handler: "getListDebounced",
        immediate: true,
      },
      'subcorrida.terminal_destino': {
        handler: "getListDebounced",
        immediate: true,
      },
      'venta.efectivo': {
        handler: "changeMetodoPago",
        immediate: true,
      },
      'venta.pago_deposito': {
        handler: "changeMetodoPago",
        immediate: true,
      },
      'venta.fue_reserva': {
        handler: "changeReservaPago",
        immediate: true,
      },
      'venta.es_pago_contado': {
        handler: "changePagoReserva",
        immediate: true,
      },
      'venta.pago_tarjeta': {
        handler: "changeMetodoPago",
        immediate: true,
      },
      pagination: {
        handler: "getList",
        immediate: false,
        deep: true,
      },
      payment_details: {
        handler(newVal, oldVal) {
          this.validateAge();
          if (newVal.length === 1){
            this.refreshToken(newVal[0].edad);
          }else{
            newVal.forEach((item, index) => {
              if(index === 0) return;
              if (item.edad !== newVal[index-1].edad) {
                this.refreshToken(item.edad);
              }
            });
          }
        },
        deep: true
      }
    },
  
    methods: {
      async getRol(){
         let me = await this.$store.getters["profile/me"];
         this.permisoAdmin = (me.relationships.role.id == 1);
      },
      telefonoValido() {
        return /^\d{10}$/.test(this.venta.telefono);
      },
      emailValido(){
         return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.venta.email);
      },
      payBefore(){
        if(this.venta.telefono){
          if (!this.telefonoValido()) {
            this.$notify({
                type: "danger",
                message: "El teléfono ingresado debe tener 10 dígitos",
                duration: -1
            });
            return;
          }
        }
        if(this.venta.email){
          if (!this.emailValido()) {
            this.$notify({
                type: "danger",
                message: "El email ingresado no es valido",
                duration: -1
            });
            return;
          }
        }
        if(this.venta.tarjeta != null && this.venta.tarjeta != ''){
          this.payTarjeta();
        }else{
          this.pay();
        }
      },
      async payTarjeta(){
        this.loadingSpinner = true;
        //Nombre cajero y motivo
        let me = await this.$store.getters["profile/me"];
        let username = (me.attributes.username).substr(0, 6);
        
        let pinpad = new Impresora;
        //Fecha y hora
        let fecha = pinpad.parseDate(new Date());
        //Referencia
        let referencia = 'VE-'+this.venta.ida.id+'-'+this.venta.ida.tramo.terminal_origen.abreviatura+'-'+this.venta.ida.tramo.terminal_destino.abreviatura+'-'+fecha;

        pinpad.autorizarPago(this.venta.tarjeta, username, referencia).then(respuesta => {
          if(respuesta.status === true){
            this.mensaje_error_pago_tarjeta = null;
            this.venta.folio_tarjeta = respuesta.autorizacion;
            this.mensaje_pago_tarjeta = respuesta.mensaje;
            this.disabledCancelPay = true;
            this.loadingSpinner = false;
            this.pay();
          }else{
            this.mensaje_error_pago_tarjeta = respuesta.mensaje+': '+respuesta.detalle;
            this.venta.tarjeta = null;
            this.loadingSpinner = false;
          }
        });
      },
      liberarAsientosSubcorridaIda(){
        const numero_boletos = this.payment_details.length;
        for(let i=0; i < numero_boletos; i++){
          this.deleteDetail(0);
        }
        this.venta.ida = {
          paradero_origen: null,
          paradero_destino: null,
          agencia_id: null,
          monto: null,
          email: null,
          telefono: null,
          asientos: [],
          tramos: {},
          bajada: null,
          subida: null,
          estructura: []
        };
        this.getList();
        //this.showSeleccionSubcorridaModal = true;
      },
      RemoveSocket(){
        const listener = (e) => {};
        const channel = Echo.channel(`Subcorrida.${this.venta.ida.subcorrida_id}`).listen('AsientoInteractivoEvent', listener);
        channel.subscription.unbind(channel.eventFormatter.format('AsientoInteractivoEvent'), listener);
        if(this.venta.vuelta.subcorrida != null){
          const listener = (e) => {};
          const channel = Echo.channel(`Subcorrida.${this.venta.vuelta.subcorrida_id}`).listen('AsientoInteractivoEvent', listener);
          channel.subscription.unbind(channel.eventFormatter.format('AsientoInteractivoEvent'), listener);
        }
      },
      changeSimbol(s) {
        //var accent_map = {'á':'&aacute;', 'é':'&eacute;', 'è':'e', 'í':'&iacute;','ó':'&oacute;','ú':'&uacute;','Á':'&Aacute;', 'É':'&Eacute;', 'è':'e', 'Í':'&Iacute;','Ó':'&Oacute;','Ú':'&Uacute;', 'ñ':'&ntilde;;', 'Ñ':'&Ntilde;'};
        var accent_map = {'á':'a', 'é':'e', 'è':'e', 'í':'i','ó':'o','ú':'u','Á':'a', 'É':'e', 'è':'e', 'Í':'i','Ó':'o','Ú':'u', 'Ñ':'N', 'ñ':'n'};
        if (!s) { return ''; }
        var ret = '';
        for (var i = 0; i < s.length; i++) {
          ret += accent_map[s.charAt(i)] || s.charAt(i);
        }
        return ret;
      },
      async addImageToPrint(linea){
        //transforma imagen a base64
        const getBase64FromUrl = async (url) => {
          const data = await fetch(url);
          const blob = await data.blob();
          return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob); 
            reader.onloadend = () => {
              const base64data = reader.result;   
              resolve(base64data);
            }
          });
        }
        let imagen;
        //elige imagen a imprimir según linea de ruta
        switch(linea){
          case 1:
            imagen = await getBase64FromUrl('/img/logoPrinter.png');
            return imagen;
          case 2:
            imagen = await getBase64FromUrl('/img/logoPrinter3.png');
            return imagen;
        }
      },
      async imprimir(boletos){
        //se obtienen datos de usuario autenticado
        let me = await this.$store.getters["profile/me"];
        //se obtienen datos de linea a la que corresponde el boleto
        let linea = boletos[0].ruta.linea;
        let imagen = await this.addImageToPrint(linea);
        let printer = new Impresora;
        //ciclo para montar cada componente boleto e imprimirlo
        for(let i=0; i < boletos.length; i++){
          if(this.venta_pago.fue_reserva === true){
            let tablaClass = Vue.extend(ImpresionBoletosReserva);
            let tablaInstancia = new tablaClass({
              propsData: { 
                  boleto: boletos[i],
                  user: me.attributes,
                  acumulado: this.calculateAcumulado,
                  linea: linea,
              }
            });
            let tabla_html = (tablaInstancia.$mount().$el.outerHTML).toString();
            let tabla = this.changeSimbol(tabla_html);
            printer.setAlign("center");
            printer.imagen(imagen);
            printer.setAlign("left");
            printer.html(tabla);
            printer.cut();
          }else{
            if(boletos[i].asiento === null){
              let tablaClass = Vue.extend(ImpresionBoletosBlanco);
              let tablaInstancia = new tablaClass({
                propsData: { 
                    boleto: boletos[i],
                    user: me.attributes
                }
              });
              let tabla_html = (tablaInstancia.$mount().$el.outerHTML).toString();
              let tabla = this.changeSimbol(tabla_html);
              printer.setAlign("center");
              printer.imagen(imagen);
              printer.setAlign("left");
              printer.html(tabla);
              printer.cut();
            }else{
              let tablaClass = Vue.extend(ImpresionBoletos);
              //let tablaClass2 = Vue.extend(ImpresionBoletos2);
              let tablaInstancia = new tablaClass({
                propsData: { 
                    boleto: boletos[i],
                    user: me.attributes,
                    linea: linea,
                }
              });
              /*
              let tablaInstancia2 = new tablaClass2({
                propsData: { 
                    boleto: boletos[i],
                    user: me.attributes,
                }
              });
              */
              let tabla_html = (tablaInstancia.$mount().$el.outerHTML).toString();
              //let tabla_html2 = (tablaInstancia2.$mount().$el.outerHTML).toString();
              let tabla = this.changeSimbol(tabla_html);
              //let tabla2 = this.changeSimbol(tabla_html2);
              printer.setAlign("center");
              printer.imagen(imagen);
              printer.setAlign("left");
              printer.html(tabla);
              printer.setAlign("center");
              printer.qr(boletos[i].id, 25);
              printer.cut();
              //printer.setAlign("left");
              //printer.html(tabla2);
              //printer.cut();
            }
          } 
        }
        printer.end().then(respuesta => {
          if(respuesta.status === true){
            this.reload();
          }
        });
        this.reload();
      },
      async imprimirLista(){
        //se obtienen datos de usuario autenticado
        let me = await this.$store.getters["profile/me"];
        let imagen = await this.addImageToPrint(this.listaAbordaje[0].attributes.linea);
        let printer = new Impresora;
        let tablaClass = Vue.extend(ImpresionListaAbordaje);
        if(this.activeTab === 'Ida'){
          this.corrida_impresion = this.venta.ida;
        }else{
          this.corrida_impresion = this.venta.vuelta;
        }
        
        let tablaInstancia = new tablaClass({
          propsData: { 
              lista: this.listaAbordaje,
              user: me.attributes,
              corrida: this.corrida_impresion
          }
        });
        let tabla_html = (tablaInstancia.$mount().$el.outerHTML).toString();
        let tabla = this.changeSimbol(tabla_html);
        printer.setAlign("center");
        printer.imagen(imagen);
        //printer.setAlign("left");
        printer.html(tabla);
        printer.cut();
        printer.end().then(respuesta => {
            this.reload();
        });
      },

      reload(){
        this.$router.go(this.$router.currentRoute)
      },

      salir(){
        this.showSeleccionSubcorridaModal = false;
        this.$router.push({path: "/dashboard"})
      },
      
      changeMetodoPago(){
        if(this.venta.efectivo === false){
          this.venta.efectivo_mxn = null;
          this.venta.efectivo_usd = null;
          this.venta.efectivo_usd_mxn = null;
        }
        if(this.venta.pago_tarjeta === false){
          this.venta.tarjeta = null;
          this.venta.folio_tarjeta = null;
          this.mensaje_error_pago_tarjeta = null;
        }
        else if(this.disabledCancelPay === false){
          this.venta.tarjeta = 0;
          this.venta.tarjeta = this.calculateRestante;
        }
        if(this.venta.pago_deposito === false){
          this.venta.deposito = null;
          this.venta.folio_deposito = null;
        }
      },

      changeReservaPago(){
        if(this.venta.fue_reserva){
          this.venta.es_pago_contado = false;
        }else{
          this.venta.es_pago_contado = true;
        }
      },

      changePagoReserva(){
        if(this.venta.es_pago_contado){
          this.venta.fue_reserva = false;
        }else{
          this.venta.fue_reserva = true;
        }
      },

      async validatePermisoReserva(){
        this.permiso.permiso = 'view autorizar realizar reserva';
        try {
        await this.$store.dispatch("ventas/verificacion", this.permiso);
          this.permiso_reserva = true;
        }catch (error) {
          this.permiso_reserva = false;
        }
      },

      validateHoraReserva(){
        var fecha1 = new Date();
        var fecha2 = new Date(this.venta.ida.fecha_salida);

        var diferencia = (fecha2.getTime() - fecha1.getTime()) / 1000;
        diferencia /= (60 * 60);
        
        if(this.horas_eliminar_reserva_antes_salida <= diferencia){
          return true;
        }else{
          return false;
        }
      },

      validateBlancos(){       
        var existe = false;
        for(let i = 0; i < this.payment_details.length; i++){
          if(this.payment_details[i].es_blanco === 1){
            existe = true;
            break;
          }
        }
        return existe;
      },

      validateReserva(){
        var hora = this.validateHoraReserva();
        var blancos = this.validateBlancos();
        if((this.reservar_activado === '0') || (this.permiso_reserva === false) || (hora === false) || (blancos == true)){
          this.reserva = false;
        }else{
          this.reserva = true;
        }
      },

      async getOpciones(){
        await this.$store.dispatch("opciones/list");
        const opciones = await { ...this.$store.getters["opciones/list"] };
        this.venta.tasa_usd_mxn = opciones.data[5].attributes.valor;
        this.reservar_activado = opciones.data[7].attributes.valor;
        this.horas_eliminar_reserva_antes_salida = opciones.data[4].attributes.valor;
        this.porcentaje_minimo_abono = opciones.data[0].attributes.valor;
      },

      isDisabledButtonAsiento(index){
        if(this.payment_details[index] !== undefined){
          if((this.activeTab === 'Ida' && this.payment_details[index].tipo_viaje === 'Ida') || (this.activeTab === 'Vuelta' && this.payment_details[index].tipo_viaje === 'Vuelta')){
            return false;
          }else{
            return true;
          }
        }
      },

      async pay(){
        if(this.venta.fue_reserva){
          const total_a_pagar = (this.porcentaje_minimo_abono * .01) * this.calculateTotal;
          this.venta_pago.monto_real = this.calculateAcumulado;
          if(total_a_pagar > this.calculateAcumulado){
            this.$notify({
              type: "danger",
              message: "No se cubre el porcentaje minimo del pago!",
              duration: -1
            });
            return;
          }
        }
        
        if(this.venta.es_pago_contado && Number(this.calculateTotal) > Number(this.calculateAcumulado)){
          this.$notify({
            type: "danger",
            message: "No se cubre el monto total del pago!",
            duration: -1
          });
          return;
        }

        if(this.venta.es_pago_contado){
          this.venta_pago.monto_real = this.calculateTotal;
        }
        this.venta_pago.token_id = this.token_id;
        
        if(this.venta.vuelta.estructura != undefined){
          this.venta_pago.es_redondo = true;
          this.venta_pago.corrida_vuelta_id = this.venta.vuelta.corrida_id;
          this.venta_pago.subcorrida_vuelta_id = this.venta.vuelta.subcorrida_id;
          this.venta_pago.ruta_vuelta_id = this.venta.vuelta.ruta_id;
          var fecha_salida_vuelta = this.venta.vuelta.fecha_salida_real;
          fecha_salida_vuelta = fecha_salida_vuelta.substr(0, fecha_salida_vuelta.length - 1);
          fecha_salida_vuelta = fecha_salida_vuelta.substr(0, fecha_salida_vuelta.length - 1);
          fecha_salida_vuelta = fecha_salida_vuelta.substr(0, fecha_salida_vuelta.length - 1);
          this.venta_pago.fecha_salida_vuelta = fecha_salida_vuelta;
          this.venta_pago.paradero_origen_vuelta = this.venta.vuelta.subida;
          this.venta_pago.paradero_destino_vuelta = this.venta.vuelta.bajada;
        }else{
          this.venta_pago.es_redondo = false;
          this.venta_pago.corrida_vuelta_id = null;
          this.venta_pago.subcorrida_vuelta_id = null;
          this.venta_pago.ruta_vuelta_id = null;
          this.venta_pago.fecha_salida_vuelta = null;
          this.venta_pago.paradero_origen_vuelta = null;
          this.venta_pago.paradero_destino_vuelta = null;
        }
        //this.venta_pago.fecha_salida_ida = this.venta.ida.fecha_salida;
        
        var fecha_salida_ida = this.venta.ida.fecha_salida_real;
        fecha_salida_ida = fecha_salida_ida.substr(0, fecha_salida_ida.length - 1);
        fecha_salida_ida = fecha_salida_ida.substr(0, fecha_salida_ida.length - 1);
        fecha_salida_ida = fecha_salida_ida.substr(0, fecha_salida_ida.length - 1);
        this.venta_pago.fecha_salida_ida = fecha_salida_ida;
        
        this.venta_pago.corrida_ida_id = this.venta.ida.corrida_id;
        this.venta_pago.subcorrida_ida_id = this.venta.ida.subcorrida_id;
        this.venta_pago.ruta_ida_id = this.venta.ida.ruta_id;
        this.venta_pago.paradero_origen_ida = this.venta.ida.subida;
        this.venta_pago.paradero_destino_ida = this.venta.ida.bajada;
        this.venta_pago.es_pago_contado = this.venta.es_pago_contado;
        this.venta_pago.fue_reserva = this.venta.fue_reserva;
        this.venta_pago.email = this.venta.email;
        this.venta_pago.telefono = this.venta.telefono;
        this.venta_pago.email = this.venta.email;
        if(this.subcorrida.agencia != null){
          this.venta_pago.agencia_id = this.subcorrida.agencia.id;
        }else{
          this.venta_pago.agencia_id = null;
        }
        this.venta_pago.token = this.venta.token;
        this.venta_pago.efectivo_mxn = this.venta.efectivo_mxn;
        this.venta_pago.efectivo_usd = this.venta.efectivo_usd;
        this.venta_pago.tasa_usd_mxn = this.venta.tasa_usd_mxn;
        this.venta_pago.efectivo_usd_mxn = (this.venta.tasa_usd_mxn * this.venta.efectivo_usd);
        if(this.venta_pago.efectivo_usd_mxn === 0){
          this.venta_pago.efectivo_usd_mxn = null;
        }
        this.venta_pago.tarjeta = this.venta.tarjeta;
        if(this.venta_pago.tarjeta === 0){
          this.venta_pago.tarjeta = null;
        }
        this.venta_pago.folio_tarjeta = this.venta.folio_tarjeta;
        this.venta_pago.deposito = this.venta.deposito;
        if(this.venta_pago.deposito === 0){
          this.venta_pago.deposito = null;
        }
        this.venta_pago.folio_deposito = this.venta.folio_deposito;
        this.venta_pago.monto = this.calculateTotal;
        
        this.venta_pago.monto_descuento = this.calculateTotal;
        this.venta_pago.total_metodos = this.calculateAcumulado;
        this.venta_pago.cambio = this.calculateCambio;
        this.venta_pago.saldo_efectivo_mxn = this.venta.efectivo_mxn - this.calculateCambio;
        this.venta_pago.asientos = this.payment_details;
        try {
        await this.$store.dispatch("ventas/add", this.venta_pago).then(() => {
          this.boletos = this.$store.getters["ventas/add"];
          this.boletos = this.boletos.result.boletos;
        });
        this.$notify({
          type: "success",
          message: "Venta realizada satisfactoriamente.",
          duration: -1
        });
        this.RemoveSocket();
        this.imprimir(this.boletos);
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      },

      async refreshToken(edad) {
        if (!edad || edad > 120) return;
        let token = {};
        token.token_id = this.token_id;
        token.canal = 1;
        try {
          await this.$store.dispatch("ventas/actualizarToken", token);
        } catch (error) {
          console.error("Error al refrescar info:", error);
        }
      },

      validateAge(){
        let total = 0;
        for(let i = 0; i < this.payment_details.length; i++){
          if(this.payment_details[i].edad !== undefined){
            if(this.payment_details[i].edad < 18){
              total++;
            }
          }
        }
        if(this.payment_details.length === total && this.payment_details.length !== 0){
          this.validacionEdad = true;
        }else{
          this.validacionEdad = false;
        }
      },

      validateTickets(){
        const ida = this.venta.ida;
        if(ida && ida.subida && ida.bajada && ida.subida === ida.bajada) {
          this.$notify({
            type: "danger",
            message: "El paradero de subida y bajada no pueden ser iguales. Verifica la corrida seleccionada.",
            duration: -1
          });
          return;
        }
        let pasa = true;
        let descuento = 0;
        for(let i = 0; i < this.payment_details.length; i++){
          if(this.payment_details[i].asiento === ' '){
            pasa = false;
            this.$notify({
              type: "danger",
              message: "Existen boletos sin asiento asignado",
              duration: -1
            });
            break;
          }
          if(this.payment_details[i].nombre_pasajero === undefined){
            pasa = false;
            this.$notify({
              type: "danger",
              message: "Existen boletos sin nombre",
              duration: -1
            });
            break;
          }
          if(this.payment_details[i].edad === undefined){
            pasa = false;
            this.$notify({
              type: "danger",
              message: "Existen boletos sin edad",
              duration: -1
            });
            break;
          }
          if(this.payment_details[i].descuento != undefined){
            if(this.payment_details[i].descuento.tipo_descuento === 'Especial'){
              descuento++;
            }
          }
        } 
        if(pasa){
          if(descuento > 0){
            this.validatePermisoPago();
          }else{
            this.payTickets();
          }
        }
      },

      payTickets(){
        this.validateReserva();
        this.venta.efectivo = true;
        this.refreshToken(1);
        this.showPayTicketModal = true;
      },

      async validatePermisoPago(){
        this.permiso.permiso = 'view autorizar descuento';
        try {
        await this.$store.dispatch("ventas/verificacion", this.permiso);
          this.payTickets();
        }catch (error) {
          this.payTickets();
          this.showAutorizaPagoDescuentoModal = true;
        }
      },

      async authPagoDescuento(){
        //this.auth.permiso = 'view autorizar descuento';
        try {
          await this.$store.dispatch("ventas/autorizacionToken", this.auth).then(() => {
            this.venta.token = this.$store.getters["ventas/autorizacionToken"];
            this.venta.token = this.venta.token.result.token;
          });
          this.$notify({
            type: "success",
            message: "Pago con descuento autorizado satisfactoriamente.",
            duration: -1
          });
          this.showAutorizaPagoDescuentoModal = false;
          } catch (error) {
            if (error.response.data.errors[0]) {
                this.$notify({
                    type: "danger",
                    message: error.response.data.errors[0].detail,
                    duration: -1
                });
            } else {
                this.$notify({
                    type: "danger",
                    message: "Oops, ha ocurrido un problema!",
                    duration: -1
                });
            }
            this.resetApiValidation();
            this.setApiValidation(error.response.data.errors);
          }
      },
      //calcula ultima fila de boletos seleccionados
      calculateFinal(index){
        var result=0.0;
        if(this.payment_details[index] !== undefined){
          if(this.payment_details[index].monto_canje === undefined){
            this.payment_details[index].monto_canje = 0;
          }
          if(this.payment_details[index].descuento === undefined || this.payment_details[index].descuento === null){
            result = parseInt(this.payment_details[index].precio_taquilla);
            this.payment_details[index].descuento = { tipo_valor: '$', valor: 0 };
          }else{
            if(this.payment_details[index].descuento.tipo_valor === '%'){
              result = parseInt(this.payment_details[index].precio_taquilla) - (parseInt(this.payment_details[index].precio_taquilla) * (parseInt(this.payment_details[index].descuento.valor)/100));
              this.payment_details[index].monto_descuento = (parseInt(this.payment_details[index].precio_taquilla) * (parseInt(this.payment_details[index].descuento.valor)/100)); 
            }else{
              result = parseInt(this.payment_details[index].precio_taquilla) - parseInt(this.payment_details[index].descuento.valor);
              this.payment_details[index].monto_descuento = parseInt(this.payment_details[index].descuento.valor); 
            }
          }
        }
        return result;
      },

      getIdaOVuelta(){
        return this.activeTab;
      },

      async createToken(){
        const data = {
          attributes: {}
        };
        data.attributes.canal = 1;
        await this.$store.dispatch("ventas/crearToken", data).then(() => {
          this.token_id = this.$store.getters["ventas/crearToken"];
          this.token_id = this.token_id.result.token_id;
        });
      },

      countDiscounts(limite_descuentos, id){
        let total = 0;
        for(let i=0; i < this.payment_details.length; i++){
          if(this.payment_details[i].descuento != undefined){
            if(this.payment_details[i].descuento.id === id){
              total++;
            }
          } 
        }
        if(total <= limite_descuentos){
          return true;
        }else{
          return false;
        }
      },

      async checkDescuento(descuento, index){
        
        var data = [];
        if(this.activeTab === 'Ida'){
          data.corrida_id = this.venta.ida.corrida_id;
        }else{
          data.corrida_id = this.venta.vuelta.corrida_id;
        }
        data.descuento_id = descuento.id;
        await this.$store.dispatch("descuentos/getTotalPorCorrida", data).then(() => {
          this.descuento_validacion = this.$store.getters["descuentos/getTotalPorCorrida"];
        });
        
        let validacion = this.countDiscounts((Number(descuento.cantidad_maxima) - Number(this.descuento_validacion.result)), descuento.id);

        if(this.descuento_validacion.success && validacion){
          this.$notify({
            type: "success",
            message: "Descuento asignado satisfactoriamente.",
            duration: -1
          });
        }else{
          this.$notify({
            type: "danger",
            message: `No existen más descuentos ${descuento.nombre} disponibles.`,
            duration: -1
          });
          this.payment_details[index].descuento = null;
          return;
        }

        if(descuento.mensaje_taquilla != null){
          this.mensaje_taquilla = descuento.mensaje_taquilla;
          this.showDescuentoMensajeTaquilla = true;
        }

        if(descuento.nombre === 'CORTESIA'){
          if (this.cortesia_razon_global) {
            if (this.payment_details[index]) {
              this.payment_details[index].cortesia_razon = this.cortesia_razon_global;
            }
          } else {
            this.cortesia.id = descuento.id;
            this.cortesia_index = index;
            this.showDescuentoCortesia = true;
          }
        } else {
          if (this.payment_details[index]) {
            this.payment_details[index].cortesia_razon = null;
          }
        }
      },

      aceptarCortesia(){
        if(!this.cortesia.razon || this.cortesia.razon.trim() === ''){
          this.$notify({
            type: "danger",
            message: "Debes describir la razón para aplicar la cortesía.",
            duration: -1
          });
          return;
        }
        this.cortesia_razon_global = this.cortesia.razon.trim();
        if(this.cortesia_index !== null && this.payment_details[this.cortesia_index]){
          this.payment_details[this.cortesia_index].cortesia_razon = this.cortesia_razon_global;
        }
        this.payment_details.forEach(detail => {
          if (detail.descuento && detail.descuento.nombre === 'CORTESIA') {
            detail.cortesia_razon = this.cortesia_razon_global;
          }
        });
        this.showDescuentoCortesia = false;
        this.cortesia.razon = null;
        this.cortesia.id = null;
        this.cortesia_index = null;
      },
      /*
      //valida si existen asientos disponible de categoria
      validationBlancosDisponibles(categoria){
        let total = 0;
        if(this.activeTab === 'Ida'){
          for(let i = 0; i < this.venta.ida.estructura[0].length; i++){
            for(let j = 0; j < this.venta.ida.estructura[0][i].length; j++){
              if(this.venta.ida.estructura[0][i][j] != null && this.venta.ida.estructura[0][i][j].tipo == 'asiento'){
                if(this.venta.ida.estructura[0][i][j].categoria.nombre === categoria && this.venta.ida.estructura[0][i][j].disponible === 1){
                  total++;
                }
              }
            }
            if(this.venta.ida.estructura[1] != null){
              for(let j = 0; j < this.venta.ida.estructura[1].length; j++){
                if(this.venta.ida.estructura[1][i][j] != null && this.venta.ida.estructura[1][i][j].tipo == 'asiento'){
                  if(this.venta.ida.estructura[1][i][j].categoria.nombre === categoria && this.venta.ida.estructura[1][i][j].disponible === 1){
                    total++;
                  }
                }
              }
            }
          }
        }else{
          for(let i = 0; i < this.venta.vuelta.estructura[0].length; i++){
            for(let j = 0; j < this.venta.vuelta.estructura[0][i].length; j++){
              if(this.venta.vuelta.estructura[0][i][j] != null && this.venta.vuelta.estructura[0][i][j].tipo == 'asiento'){
                if(this.venta.vuelta.estructura[0][i][j].categoria.nombre === categoria && this.venta.vuelta.estructura[0][i][j].disponible === 1){
                  total++;
                }
              }
            }
            if(this.venta.vuelta.estructura[1] != null){
              for(let j = 0; j < this.venta.vuelta.estructura[1].length; j++){
                if(this.venta.vuelta.estructura[1][i][j] != null && this.venta.vuelta.estructura[1][i][j].tipo == 'asiento'){
                  if(this.venta.vuelta.estructura[1][i][j].categoria.nombre === categoria && this.venta.vuelta.estructura[1][i][j].disponible === 1){
                    total++;
                  }
                }
              }
            }
          }
        }
        return total;
      },

      validationTotalBlancos(categoria_id){
        let total = 1;
        for(let i = 0; i < this.payment_details.length; i++){
          if(this.payment_details[i].categoria.id === categoria_id){
            total++;
          }
        }
        return total;
      },*/

      addBlancoPrimera(){
        let precio = this.venta.ida.precios.filter(item => item.nombre == "Básica");
        this.payment_details.push({
          tipo_viaje: this.activeTab, 
          asiento: 'B B',
          categoria: {id: 1},
          precio_taquilla: precio[0].precio_taquilla,
          es_blanco: 1,
          descuento: undefined,
          numero: null,
          monto_canje: 0,
        });
      },

      addBlancoEjecutiva(){
        let precio = this.venta.ida.precios.filter(item => item.nombre == "Ejecutiva");
        this.payment_details.push({
          tipo_viaje: this.activeTab, 
          asiento: 'B E',
          categoria: {id: 2},
          precio_taquilla: precio[0].precio_taquilla,
          es_blanco: 1,
          descuento: undefined,
          numero: null,
          monto_canje: 0,
        });
      },

      addBlancoConfort(){
        let precio = this.venta.ida.precios.filter(item => item.nombre == "Confort");
        this.payment_details.push({
          tipo_viaje: this.activeTab, 
          asiento: 'B C',
          categoria: {id: 3},
          precio_taquilla: precio[0].precio_taquilla,
          es_blanco: 1,
          descuento: undefined,
          numero: null,
          monto_canje: 0,
        });
      },

      addDetail(asiento){
        let categoriaNombre;
        if(asiento.categoria.nombre != undefined){
          categoriaNombre = asiento.categoria.nombre.charAt(0);
        }else{
          categoriaNombre = asiento.categoria;
        }
        if(this.cambiando_asiento){
          this.payment_details[this.asiento_index].asiento = asiento.numero+' '+categoriaNombre;
          this.payment_details[this.asiento_index].numero = asiento.numero;
          this.payment_details[this.asiento_index].categoria = asiento.categoria;
          this.payment_details[this.asiento_index].es_blanco = 0;
          this.payment_details[this.asiento_index].precio_taquilla = asiento.precio_taquilla;
          this.payment_details[this.asiento_index].monto_canje = asiento.monto_canje;
          this.payment_details[this.asiento_index].id = asiento.id;
          this.payment_details[this.asiento_index].descuento = undefined;
          this.payment_details[this.asiento_index].classActive = false;
          this.payment_details[this.asiento_index].nivel = this.nivelActual;
          this.cambiando_asiento = false;
          this.asiento_index = null;
        }else{
          this.payment_details.push({
            tipo_viaje: this.activeTab, 
            classActive: false,
            asiento: asiento.numero+' '+categoriaNombre,
            numero: asiento.numero,
            es_blanco: 0,
            categoria: asiento.categoria,
            precio_taquilla: asiento.precio_taquilla,
            monto_canje: asiento.monto_canje,
            id: asiento.id,
            descuento: undefined,
            nivel: this.nivelActual 
          });
        }
        //this.customer_detail_id= 0;
      },

      changeDetail(index){
        this.cambiando_asiento = true;
        this.asiento_index = index;
        this.payment_details[index].asiento = ' ';
        this.payment_details[index].classActive = true;
        this.payment_details[index].es_blanco = 0;
        if(this.payment_details[index].id != undefined && this.payment_details[index].tipo_viaje === 'Ida'){
          const id = this.payment_details[index].id;
          const item = this.$refs[id];
          if(this.payment_details[index].nivel === '1'){
            item[0].resetAsiento();
          }else{
            if(item.length === 2){
              item[1].resetAsiento();
            }else{
              item[0].resetAsiento();
            }
          }
        }
        if(this.payment_details[index].id != undefined && this.payment_details[index].tipo_viaje === 'Vuelta'){
          const id = this.payment_details[index].id;
          const item = this.$refs[id];
          if(this.payment_details[index].nivel === '1'){
            item[0].resetAsiento();
          }else{
            if(item.length === 2){
              item[1].resetAsiento();
            }else{
              item[0].resetAsiento();
            }
          }
        }
        //this.payment_details.splice(index,1,'asiento');
      },

      deleteDetail(index){
        if(this.payment_details[index].id != undefined && this.payment_details[index].tipo_viaje === 'Ida'){
          const id = this.payment_details[index].id;
          const item = this.$refs[id];
          //console.log('asiento')
          //console.log(this.payment_details[index])
          //console.log('refs ida')
          //console.log(item)
          if(this.payment_details[index].nivel === '1'){
            item[0].resetAsiento();
          }else{
            if(item.length === 2){
              item[1].resetAsiento();
            }else{
              item[0].resetAsiento();
            }
          }
          this.payment_details.splice(index,1);
        }else if(this.payment_details[index].id != undefined && this.payment_details[index].tipo_viaje === 'Vuelta'){
          const id = this.payment_details[index].id;
          const item = this.$refs[id];
          if(this.payment_details[index].nivel === '1'){
            item[0].resetAsiento();
          }else{
            if(item.length === 2){
              item[1].resetAsiento();
            }else{
              item[0].resetAsiento();
            }
          }
          this.payment_details.splice(index,1);
        }else{
          this.payment_details.splice(index,1);
        }
      },
      //resetea valores de venta vuelta
      resetVentaVuelta(){
        const numero_boletos = this.payment_details.length;
        for(let i=0; i < numero_boletos; i++){
          if(this.payment_details.length > 0 && this.payment_details[i].tipo_viaje === 'Vuelta'){
            this.deleteDetail(i);
            i--;
          }
        }
        this.venta.vuelta = {
          paradero_origen: null,
          paradero_destino: null,
          agencia_id: null,
          monto: null,
          email: null,
          telefono: null,
          asientos: [],
          tramos: {},
          bajada: null,
          subida: null,
          estructura: []
        };
        //obtiene asientos de ida y elimina los de vuelta para el reset de corrida-subcorrida
        //const array_asientos_ida = this.payment_details.filter(i => i.tipo_viaje === 'Ida');
        //this.payment_details = array_asientos_ida;
        this.showSeleccionSubcorridaModal = true;
      },

      //carga datos iniciales de venta
      async handleCurrentChange(val) {
        console.log('llega');
        if(val === null) return;
        const requestId = ++this.subcorridaRequestId;

        console.log(requestId)
        console.log(this.subcorridaRequestId)
        await this.createToken();
        await this.$store.dispatch("subcorridas/getDatosVenta", val.id).then(() => {
          if(requestId !== this.subcorridaRequestId) return;
          if(this.activeTab === 'Ida'){
            const ida = this.venta.ida;
            const ida_carga = this.$store.getters["subcorridas/getDatosVenta"];
            this.venta.ida = Object.assign(ida, ida_carga);
            this.venta.ida.subida = null;
            this.venta.ida.bajada = null;
            const paraderos_ida = JSON.parse(this.venta.ida.tramo.terminal_origen.paraderos);
            this.venta.ida.paraderos_ida = paraderos_ida;
            const paraderos_vuelta = JSON.parse(this.venta.ida.tramo.terminal_destino.paraderos);
            this.venta.ida.paraderos_vuelta = paraderos_vuelta;
            this.venta.ida.subida = paraderos_ida.length > 0 ? paraderos_ida[0] : null;
            this.venta.ida.bajada = paraderos_vuelta.length > 0 ? paraderos_vuelta[0] : null;
            //this.venta.ida.subida = paraderos_ida[0];
            //this.venta.ida.bajada = paraderos_vuelta[0];
            this.getDescuentos(this.venta.ida.subcorrida_id);

            //Validacion de precios faltantes para subcorrida ida
            if(this.venta.ida.precios_taquilla_faltantes.length > 0){
              if(this.venta.ida.precios_taquilla_faltantes.length === 1){
                this.$notify({
                  type: "danger",
                  message: `¡No existen precios vigentes de ${this.venta.ida.precios_taquilla_faltantes[0]} para subcorrida seleccionada!`,
                  duration: -1
                });
              }
              if(this.venta.ida.precios_taquilla_faltantes.length === 2){
                this.$notify({
                  type: "danger",
                  message: `¡No existen precios vigentes de ${this.venta.ida.precios_taquilla_faltantes[0]} y ${this.venta.ida.precios_taquilla_faltantes[1]} para subcorrida seleccionada!`,
                  duration: -1
                });
              }
              if(this.venta.ida.precios_taquilla_faltantes.length === 3){
                this.$notify({
                  type: "danger",
                  message: `¡No existen precios vigentes de ${this.venta.ida.precios_taquilla_faltantes[0]}, ${this.venta.ida.precios_taquilla_faltantes[1]} y ${this.venta.ida.precios_taquilla_faltantes[2]} para subcorrida seleccionada!`,
                  duration: -1
                });
              }
                this.venta.ida = {};
              }else{
                this.venta.token_id = this.token_id;
                this.showSeleccionSubcorridaModal = false;
              }
          }else{
            //this.resetVentaVuelta();
            const vuelta = this.venta.vuelta;
            const vuelta_carga = this.$store.getters["subcorridas/getDatosVenta"];
            this.venta.vuelta = Object.assign(vuelta, vuelta_carga);
            this.venta.vuelta.subida = null;
            this.venta.vuelta.bajada = null;
            const paraderos_ida = JSON.parse(this.venta.vuelta.tramo.terminal_origen.paraderos);
            this.venta.vuelta.paraderos_ida = paraderos_ida;
            const paraderos_vuelta = JSON.parse(this.venta.vuelta.tramo.terminal_destino.paraderos);
            this.venta.vuelta.paraderos_vuelta = paraderos_vuelta;
            this.venta.vuelta.subida = paraderos_ida.length > 0 ? paraderos_ida[0] : null;
            this.venta.vuelta.bajada = paraderos_vuelta.length > 0 ? paraderos_vuelta[0] : null;
            //this.venta.vuelta.subida = paraderos_ida[0];
            //this.venta.vuelta.bajada = paraderos_vuelta[0];
            this.getDescuentosVuelta(this.venta.vuelta.subcorrida_id);
            
            //Validacion de precios faltantes para subcorrida vuelta
            if(this.venta.vuelta.precios_taquilla_faltantes.length > 0){
              if(this.venta.vuelta.precios_taquilla_faltantes.length === 1){
                this.$notify({
                  type: "danger",
                  message: `¡No existen precios vigentes de ${this.venta.vuelta.precios_taquilla_faltantes[0]} para subcorrida seleccionada!`,
                  duration: -1
                });
              }
              if(this.venta.vuelta.precios_taquilla_faltantes.length === 2){
                this.$notify({
                  type: "danger",
                  message: `¡No existen precios vigentes de ${this.venta.vuelta.precios_taquilla_faltantes[0]} y ${this.venta.vuelta.precios_taquilla_faltantes[1]} para subcorrida seleccionada!`,
                  duration: -1
                });
              }
              if(this.venta.vuelta.precios_taquilla_faltantes.length === 3){
                this.$notify({
                  type: "danger",
                  message: `¡No existen precios vigentes de ${this.venta.vuelta.precios_taquilla_faltantes[0]}, ${this.venta.vuelta.precios_taquilla_faltantes[1]} y ${this.venta.vuelta.precios_taquilla_faltantes[2]} para subcorrida seleccionada!`,
                  duration: -1
                });
              }
                this.venta.vuelta = {};
              }else{
                this.venta.token_id = this.token_id;
                this.showSeleccionSubcorridaModal = false;
              }
          }
        });
      },

      nivelUno(){   
        this.mostrarNivelUno = true;
        this.mostrarNivelDos = false;
        this.nivelActual = '1';
      },

      nivelDos(){
        this.mostrarNivelUno = false;
        this.mostrarNivelDos = true;
        this.nivelActual = '2';
      },

      //control de tab
      handleClick(){
        if(this.activeTab === 'Vuelta' && this.vuelta === false){
          this.subcorridas = [];
          this.showSeleccionSubcorridaModal = true;
          this.vuelta = true;
          this.subcorrida.fecha_salida = new Date();
          this.Intercambiar();
        }
      },

      async listaAbordajeModal($id){
        await this.$store.dispatch("corridas/listAbordaje", $id).then(() => {
          this.listaAbordaje = this.$store.getters["corridas/listAbordaje"];
        });
        await this.$store.dispatch("corridas/getTotalVentaCorrida", $id).then(() => {
            this.TotalVentaCorrida = this.$store.getters["corridas/getTotalVentaCorrida"];
        });
        this.showListaAbordajeModal = true;
      },

      getListDebounced: _.debounce(function () {
        this.getList();
      }, 300),
      
      //trae subcoridas
      async getList() {
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
          },
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
          fecha_salida: this.subcorrida.fecha_salida,
          ...(this.subcorrida.terminal_origen ? { terminal_origen_id: this.subcorrida.terminal_origen.id } : {}),
          ...(this.subcorrida.terminal_destino ? { terminal_destino_id: this.subcorrida.terminal_destino.id } : {}),
        };
        var fecha_salida = new Date((this.subcorrida.fecha_salida).setHours(0, 0, 0, 0));
        var hoy = new Date((this.subcorrida.hoy).setHours(0, 0, 0, 0));
        if(fecha_salida < hoy){
          this.subcorrida.fecha_salida = new Date();
          this.subcorrida.hoy = new Date();
          this.$notify({
            type: "danger",
            message: "No es posible seleccionar una fecha menor a la actual!",
            duration: -1
          });
        }else{
          try{
          if(this.subcorrida.terminal_origen && this.activeTab === 'Ida'){
          this.subcorrida.fecha_salida_ida = this.subcorrida.fecha_salida;
            await this.$store.dispatch("subcorridas/list", params).then(() => {
              this.subcorridas = this.$store.getters["subcorridas/list"];
              this.total = this.$store.getters["subcorridas/listTotal"];
          });
          }
          if(this.activeTab === 'Vuelta'){
            if(this.subcorrida.fecha_salida >= this.subcorrida.fecha_salida_ida){
              await this.$store.dispatch("subcorridas/list", params).then(() => {
                this.validacion_fecha_salida = null;
                this.subcorridas = this.$store.getters["subcorridas/list"];
                this.total = this.$store.getters["subcorridas/listTotal"];
              });
            }else{
              this.validacion_fecha_salida = 'Selecciona una fecha de salida igual o mayor a la de ida';
              this.subcorridas = [];
              this.total = 0;
            }
          }
          this.showSeleccionSubcorridaModal = true;
          this.loading = false;
          }catch (error) {
            if (error.response.data.errors[0]) {
                this.$notify({
                    type: "danger",
                    message: error.response.data.errors[0].detail,
                    duration: -1
                });
            } else {
                this.$notify({
                    type: "danger",
                    message: "Oops, ha ocurrido un problema!",
                    duration: -1
                });
            }
            this.resetApiValidation();
            this.setApiValidation(error.response.data.errors);
          }
        }
      },

      async getTerminales() {
        let params = {
          filter: {
          },
          page: {
            number: 1,
            size: 100000,
          },
        };
        let me = await this.$store.getters["profile/me"];
        await this.$store.dispatch("terminales/list", params).then(() => {
          this.terminales = this.$store.getters["terminales/list"];
          if(me.attributes.agencia_activa != 'sin agencia'){
            this.subcorrida.agencia = me.relationships.agencias.data.find(item => item.attributes.nombre == me.attributes.agencia_activa);
            this.subcorrida.terminal_origen = this.terminales.find(item => item.nombre == this.subcorrida.agencia.attributes.terminal.attributes.nombre);
          }else{
            this.subcorrida.agencia = null;
          }
        });
      },

      async getDescuentos(id){
        await this.$store.dispatch("descuentos/listActive", id).then(() => {
          this.descuentos = this.$store.getters["descuentos/listActive"];
        });
      },

      async getDescuentosVuelta(id){
        await this.$store.dispatch("descuentos/listActive", id).then(() => {
          this.descuentosVuelta = this.$store.getters["descuentos/listActive"];
        });
      },

      nombreAbreviatura ({ nombre, abreviatura }) {
        return `${nombre} (${abreviatura})`
      },

      closeModal() {
        if(this.showSeleccionSubcorridaModal == true){
          this.showSeleccionSubcorridaModal = false;
        }else{
          //this.showEditModal = false;
        }
        this.resetApiValidation();
      },

      Intercambiar(){
        let terminal_origen = this.subcorrida.terminal_origen;
        let terminal_destino = this.subcorrida.terminal_destino;
        this.subcorrida.terminal_origen = terminal_destino;
        this.subcorrida.terminal_destino = terminal_origen;
        if(this.subcorrida.terminal_origen === null){
          this.subcorrida.terminal_origen = this.terminales.find(item => item.nombre == this.venta.ida.tramo.terminal_destino.nombre);
        }
      },

      sortChange({ prop, order }) {
        if (order === "descending") {
          this.sort = `-${prop}`;
        } else {
          this.sort = `${prop}`;
        }
        this.getList();
      },
    },
  };
  </script>
  <style>
  .hoverApolo:hover{
      background-color: #6074dd !important;
      color: #fff !important;
  }
</style>